module.exports = __webpack_public_path__ + "img/moviejoy-alternatives.924e18c1.webp";